/*
 * COPYRIGHT 2022-2024 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import React, { Component } from 'react';
import { ColumnHeading, Frame, InputType, ListView, SortOrder, TableView } from 'yospace-ui-components';
import { EventDataStyles, StatusViewStyles } from './LivePageStyles';
import { v4 as uuid } from 'uuid';
import { EventStatus } from '../common/EventStatus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStethoscope } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { ReactComponent as Logo } from "../icons/capella.svg";
import {YOSPACE_GRAFANA_URL, YOSPACE_EVENT_STREAM_MANAGER_API_URL} from "../common/Urls"
import UserService from "../common/UserService";

class StatusView extends Component {
    constructor(props) {
        super(props);

        this.handleCapellaButtonClick = this.handleCapellaButtonClick.bind(this);
        this.handleGrafanaButtonClick = this.handleGrafanaButtonClick.bind(this);
        this.handleLiveButtonClick = this.handleLiveButtonClick.bind(this);
    }

    getEventStatus() {
        if (this.props.data && this.props.data.schedule) {
            let start = new Date(this.props.data.schedule.start_dt).getTime();
            let end = new Date(this.props.data.schedule.end_dt).getTime();
            let now = Date.now();

            if (this.props.data.tasks) {
                for (let t of this.props.data.tasks) {
                    if (t.task_type === "CREATE_CAPELLA_STREAM") {
                        if (t.execution_end_dt === null && t.execution_start_dt !== null) {
                            return EventStatus.PROVISIONING;
                        }

                        if (t.execution_start_dt !== null && t.execution_end_dt !== null && t.success === true && start >= now) {
                            return EventStatus.READY;
                        }
                    }
                }
            }

            if (start <= now && end >= now) {
                return EventStatus.LIVE;
            }

            if (start > now) {
                if (start - now < 1000 * 60 * 2) {
                    return EventStatus.UPCOMING;
                }

                return EventStatus.SCHEDULED;
            }

            if (end < now) {
                return EventStatus.PAST;
            }
        }

        return null;
    }

    getCapellaAdBreakInsertUrl() {
        for (const task of this.props.data.tasks) {
            if (task.task_type === "CREATE_CAPELLA_STREAM") {
                return task.artefacts.capella_abc_url;
            }
        }

        return "";
    }

    getExternalResourceUrl(materialId, streamId) {
        // Use of "lefort01" is static until we have a backend that handles accounts etc.
        return YOSPACE_GRAFANA_URL.replace("CONTENT_PROVIDER", "lefort01").replace("EXTERNAL_ID", materialId).replace("FEED_ID", streamId);
    }

    handleCapellaButtonClick() {
        const url = this.getCapellaAdBreakInsertUrl();
        if (url) {
            window.open(url);
        }
    }

    handleGrafanaButtonClick() {
        const url = this.getExternalResourceUrl(this.props.data.schedule.material_id, this.props.data.stream_id);
        window.open(url);
    }

    handleLiveButtonClick() {
        let materialId = this.props.data.schedule.material_id;
        let t = new Date();
        let time = t.getHours() + "" +  t.getMinutes() + "" + t.getSeconds();
        let url = `https://csm-d-poc-euw1-001.bln1.yospace.com/csm/extlive/lefort01,${materialId}.m3u8?yo.xdp.ss=true&yo.xdp.host=csm-e-cepocluslaxlive-57044586.bln1.yospace.com&debug=${materialId}_${time}`
        window.open(url);
    }

    render() {
        let eventStatus = this.getEventStatus();
        return (
            <div style = { StatusViewStyles.getMain() } >
                <div style = { StatusViewStyles.getLabel(eventStatus) } >
                    <div style = { StatusViewStyles.getText() } >
                        { EventStatus.toString(eventStatus) }
                    </div>
                </div>
                {
                    (eventStatus === EventStatus.LIVE || eventStatus === EventStatus.PAST) &&
                        <div style = { StatusViewStyles.getExternalLinkButtonStyle(eventStatus === EventStatus.LIVE) } onClick = { this.handleGrafanaButtonClick } >
                            <FontAwesomeIcon icon = { faStethoscope } />
                        </div>
                }
                {
                    eventStatus === EventStatus.LIVE &&
                        <div style = { { display: 'table-cell' } } >
                            <div style = { StatusViewStyles.getExternalLinkButtonStyle(true) } onClick = { this.handleLiveButtonClick }>
                                <FontAwesomeIcon icon={ faYoutube }/>
                            </div>
                            {
                                this.getCapellaAdBreakInsertUrl() &&
                                    <div style={StatusViewStyles.getExternalLinkButtonStyle(true)}
                                         onClick={this.handleCapellaButtonClick}>
                                        <Logo/>
                                    </div>
                            }
                        </div>
                }
            </div>
        )
    }
}

StatusView.propTypes = {
    data: PropTypes.shape({
        stream_id: PropTypes.number,
        schedule: PropTypes.shape({
            start_dt: PropTypes.string,
            end_dt: PropTypes.string,
            material_id: PropTypes.string,
            capella_abc_url: PropTypes.string
        }),
        tasks: PropTypes.arrayOf(PropTypes.shape( {
            task_type: PropTypes.string,
            execution_start_dt: PropTypes.string,
            execution_end_dt: PropTypes.string,
            success: PropTypes.bool
        }))
    })
}

class DateView extends Component {
    render() {
        let dateText = '-';
        if (this.props.data) {
            let date = new Date(Date.parse(this.props.data));
            if (!Number.isNaN(date)) {
                let month = date.getMonth() + 1;
                month = month < 10 ? '0' + month : month;
                let dt = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
                let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
                let seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                dateText = date.getFullYear() + '-' + month + '-' + dt + ' ' + hours + "." + minutes + "." + seconds;
            }
        }

        return (
            <div>
                { dateText }
            </div>
        )
    }
}

DateView.propTypes = {
    data: PropTypes.string
}

class BreaksCountView extends Component {
    render() {
        let count = this.props.data && this.props.data.length ? this.props.data.length : 0;

        return (
            <div>
                { count }
            </div>
        )
    }
}

BreaksCountView.propTypes = {
    data: PropTypes.array
}

const PLANNED_BREAK_METADATA_FIELDS = Object.freeze([
    new TableView.Field("ID", "id", null, null, InputType.NUMERIC),
    new TableView.Field("Position", "position", null, null, null, null, false),
    new TableView.Field("Duration", "duration", null, null, null, null, false),
    new TableView.Field("Metadata", "metadata", null, null, null, null, false)
]);

class EventData extends Component {
    formatMetadata() {
        if (this.props.data && this.props.data.schedule && this.props.data.schedule.metainfo) {
            let metainfo = this.props.data.schedule.metainfo;
            // Do the pretty print and remove line breaks
            return JSON.stringify(metainfo, null, 1)
                .replaceAll('\n', '')
                .replaceAll('}', ' }');
        }

        return '-'
    }

    getFormattedDate(t) {
        let date = new Date(t);
        let month = date.getMonth() + 1;
        if (month < 10) {
            month = "0" + month;
        }

        let dt = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

        return date.getFullYear() + "-" + month + "-" + dt + " " + hours + ":" + minutes;
    }

    getPlannedBreakMetadataAsObject() {
        let data = [];

        if (this.props.data && this.props.data.schedule && this.props.data.schedule.ad_break_playlist) {
            for (let ad of this.props.data.schedule.ad_break_playlist) {
                let entry = {};
                entry.id = ad.id;
                entry.position = ad.position;
                entry.duration = ad.duration;
                entry.metadata = "ptpln=" + ad.metainfo.ptpln + ";adv_tv_break_type=" + ad.metainfo.adv_tv_break_type;
                data.push(entry);
            }
        }

        return data;
    }

    render() {
        let plannedBreakData = this.getPlannedBreakMetadataAsObject();

        return (
            <div style = { EventDataStyles.getMain() } >
                <div style = { EventDataStyles.getInner() } >
                    <div style = { EventDataStyles.getLabel() } >
                        METADATA
                    </div>
                    <div style = { EventDataStyles.getMetadataText() }  >
                        { this.formatMetadata() }
                    </div>
                </div>
                {
                    plannedBreakData.length > 0 ?
                        <div>
                            <div style={EventDataStyles.getSpacer()}/>
                            <TableView
                                noImport = { true }
                                readOnly = { true }
                                title = "PLANNED BREAK METADATA"
                                fields = { PLANNED_BREAK_METADATA_FIELDS }
                                values = { plannedBreakData }
                                height = "203px"
                            />
                        </div>
                    :
                        ''
                }
                <div style = { EventDataStyles.getSpacer() } />
                {
                    this.props.data.log && this.props.data.log.length > 0 ?
                        <Frame title = "ACTIVITY" >
                            <div id = "scrollable" style = { EventDataStyles.getTableContainer() } >
                                <table>
                                    <tbody>
                                    {
                                        this.props.data.log.map(l => (
                                            <tr>
                                                <td>
                                                    <div style = { EventDataStyles.getActivityDateText() } >
                                                        { this.getFormattedDate(l.timestamp) }
                                                    </div>
                                                </td>
                                                <td>
                                                    <div style = { EventDataStyles.getActivityText() } >
                                                        [{ l.logger }]
                                                    </div>
                                                </td>
                                                <td>
                                                    <div style = { EventDataStyles.getActivityText() } >
                                                        { l.message }
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </Frame>
                    :
                        ''
                }
            </div>
        )
    }
}

EventData.propTypes = {
    data: PropTypes.shape({
        schedule: PropTypes.shape({
            metainfo: PropTypes.shape({
                channel: PropTypes.string,
                broadcast_tied: PropTypes.string,
                tx_event_type_name: PropTypes.string
            }),
            ad_break_playlist: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.string,
                position: PropTypes.string,
                duration: PropTypes.string,
                metadata: PropTypes.shape({
                    ptpl: PropTypes.string,
                    ad_tv_break_type: PropTypes.string
                })
            }))
        }),
        log: PropTypes.arrayOf(PropTypes.shape({
            timestamp: PropTypes.string,
            logger: PropTypes.string,
            message: PropTypes.string
        }))
    })
}

const COLUMN_IDS = Object.freeze({
    ON_AIR: 0,
    OFF_AIR: 1,
    NAME: 2,
    MATERIAL_ID: 3,
    REGION: 4,
    TYPE: 5,
    BREAKS: 6,
    STATUS: 7
});

// At some point, these will be made available according to customer account
const REGION_FILTER_OPTIONS = Object.freeze([
    {
        id: "europe",
        displayName: "Europe"
    }
]);

const PROTOCOL_FILTER_OPTIONS = Object.freeze([
    {
        id: "hls",
        displayName: "HLS"
    },
    {
        id: "dash",
        displayName: "DASH"
    }
]);

const STATUS_FILTER_OPTIONS = Object.freeze([
    {
        id: EventStatus.PAST,
        displayName: EventStatus.toString(EventStatus.PAST)
    },
    {
        id: EventStatus.LIVE,
        displayName: EventStatus.toString(EventStatus.LIVE)
    },
    {
        id: EventStatus.UPCOMING,
        displayName: EventStatus.toString(EventStatus.UPCOMING)
    },
    {
        id: EventStatus.SCHEDULED,
        displayName: EventStatus.toString(EventStatus.SCHEDULED)
    }
]);

const LISTVIEW_COLUMNS = Object.freeze([
    new ListView.Column(COLUMN_IDS.ON_AIR, "On Air", "schedule.start_dt", React.createElement(DateView), null, { expandable: true }, null, { searchType: ColumnHeading.SearchType.NONE } ),
    new ListView.Column(COLUMN_IDS.OFF_AIR, "Off Air", "schedule.end_dt", React.createElement(DateView), null, null, null, { searchType: ColumnHeading.SearchType.NONE } ),
    new ListView.Column(COLUMN_IDS.NAME, "Name", "schedule.name", null,  null, null, null, { searchType: ColumnHeading.SearchType.TEXT } ),
    new ListView.Column(COLUMN_IDS.MATERIAL_ID, "Material ID", "schedule.material_id", null, { width: '96px', allowSelect: true }, null, null, { searchType: ColumnHeading.SearchType.TEXT } ),
    new ListView.Column(COLUMN_IDS.REGION, "Region", "schedule.region", null, { width: '75px'}, null, null, { searchType: ColumnHeading.SearchType.LIST, data: REGION_FILTER_OPTIONS} ),
    new ListView.Column(COLUMN_IDS.TYPE, "Type", "schedule.protocol", null, { width: '65px'}, null, null, { searchType: ColumnHeading.SearchType.LIST, data: PROTOCOL_FILTER_OPTIONS } ),
    new ListView.Column(COLUMN_IDS.BREAKS, "Breaks", "schedule.ad_break_playlist", React.createElement(BreaksCountView), { width: '50px' }, null, null, { searchType: ColumnHeading.SearchType.NONE } ),
    new ListView.Column(COLUMN_IDS.STATUS, "Status", "", React.createElement(StatusView), { maxWidth: '70px'}, null, null, { searchType: ColumnHeading.SearchType.LIST, data: STATUS_FILTER_OPTIONS } )
]);

const PAGE_SIZE = 50;

class LivePage extends Component {
    constructor(props) {
        super(props);

        this.state = { events: [], error: null };

        this.sort = { /* sortOrder: ..., columnId: ... */ };
        this.search = new Map(); // key: column id, value: search string
        this.listFilter = new Map(); // key: columnId, value: filter string
        this.firstPageRetrieved = null;
        this.lastPageRetrieved = null;
        this.requestInProgress = false;

        this.lastScrollTop = null;
        this.listViewRef = React.createRef();
        this.interval = null;

        this.handleListFilterChange = this.handleListFilterChange.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
    }

    componentDidMount() {
        this.handleFetch(0);

        this.interval = setInterval(() => {
            this.updateEvents();
        }, 10000);
    }

    updateEvents() {
        if (this.requestInProgress || !this.firstPageRetrieved) {
            return;
        }

        let page = this.firstPageRetrieved;
        let count = this.lastPageRetrieved ? this.lastPageRetrieved - this.firstPageRetrieved + 1 : 1;

        let url = YOSPACE_EVENT_STREAM_MANAGER_API_URL + "?page=" + page + "&limit=" + (PAGE_SIZE * count);

        url += this.getSortOrderQuery();
        url += this.getSortQuery();
        url += this.getSearchQuery();
        url += this.getListFilterQuery();

        const headers = new Headers();
        headers.append("Authorization", `Bearer ${UserService.getToken()}`);

        fetch(url, {
            headers: headers
        }).then(response => {
            response.json().then(data => {
                let events = [];

                let newEvents = [];

                let knownEvents = new Map();
                for (let e of this.state.events) {

                    // This will force a refresh of all events in memory.  The event state (PROVISIONING, LIVE etc.)
                    // is based on the current system time and needs to be updated when it is time to move it on. Rather
                    // than keeping track of previous states and checking which need to be changed, the StatusView
                    // component can do that for us. The cost in terms of DOM changes is negligible and will never
                    // impact upon user experience. The benefit is having a cleaner implementation where calculations
                    // are done in a single place.
                    e._time = Date.now();
                    knownEvents.set(e.schedule.material_id, e);
                }

                // Compare the events received. Store the ones we don't know about and update the ones we do
                for (let i = 0; i < data.events.length; i++) {
                    let incomingEvent = data.events[i];

                    if (!knownEvents.has(incomingEvent.schedule.material_id)) {
                        incomingEvent.id = uuid();
                        newEvents.push(incomingEvent);
                    }
                    else {
                        let existingEvent = knownEvents.get(incomingEvent.schedule.material_id);
                        incomingEvent.id = existingEvent.id;
                        for (let existing = 0; existing < this.state.events.length; ++existing) {
                            if (this.state.events[existing].id === existingEvent.id) {
                                this.state.events[existing] = incomingEvent;
                            }
                        }
                    }
                }

                events = [...newEvents, ...this.state.events];

                this.setState({events: events});
            }).catch(e => {
                this.setState({error: e, events: []});
            });
        });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.interval = null;
    }

    handleListFilterChange(columnId, id) {
        if (id !== null && id !== undefined) {
            this.listFilter.set(columnId, id);
        }
        else {
            this.listFilter.delete(columnId);
        }

        this.handleFetch(0, true);
    }

    handleScroll(scrollTop, scrollHeight, tableHeight) {
        if (scrollTop > this.lastScrollTop && scrollTop + tableHeight >= scrollHeight / 2) {
            this.handleFetch(1);
        }
        else if (scrollTop === 0) {
            this.handleFetch(-1);
        }

        this.lastScrollTop = scrollTop;

        this.scrollTop = scrollTop;
        this.scrollHeight = scrollHeight;
        this.contentTableHeight = tableHeight;
    }

    /*
     * windowDirection: one of 1, -1 or 0
     * replace: boolean (e.g. when search or sort has changed, don't assume that the page has already been fetched)
     */
    handleFetch(windowDirection, replace) {
        let nextPage = 1;

        if (this.lastPageRetrieved !== null && this.firstPageRetrieved !== null) {
            if (windowDirection === 1) {
                nextPage = this.lastPageRetrieved + 1;
            }
            else if (windowDirection === -1 ) {
                nextPage = this.firstPageRetrieved - 1;
            }
            else if (!replace) {
                return;
            }
        }

        if (nextPage < 1) {
            return;
        }

        if (this.requestInProgress) {
            return;
        }

        if ( (this.lastPageRetrieved === nextPage || this.firstPageRetrieved === nextPage) && !replace ) {
            return;
        }

        this.requestInProgress = true;

        let url = YOSPACE_EVENT_STREAM_MANAGER_API_URL + "?page=" + nextPage + "&limit=" + PAGE_SIZE;

        url += this.getSortOrderQuery();
        url += this.getSortQuery();
        url += this.getSearchQuery();
        url += this.getListFilterQuery();

        this.doFetch(url, windowDirection, nextPage, replace);
    }

    getSortOrderQuery() {
        let url = "";

        switch (this.sort.sortOrder) {
            case SortOrder.ASCENDING:
                url += "&order_by=asc:";
                break;

            case SortOrder.DESCENDING:
                url += "&order_by=desc:";
                break;

            default:
                break;
        }

        return url;
    }

    getSortQuery() {
        let url = "";

        switch (this.sort.columnId) {
            case COLUMN_IDS.ON_AIR:
                url += "start_dt";
                break;

            case COLUMN_IDS.OFF_AIR:
                url += "end_dt";
                break;

            case COLUMN_IDS.NAME:
                url += "name";
                break;

            case COLUMN_IDS.MATERIAL_ID:
                url += "material_id";
                break;

            case COLUMN_IDS.STATUS:
                url += "start_dt";
                break;

            default:
                break;
        }

        return url;
    }

    getSearchQuery() {
        let url = "";

        for (let [key, value] of this.search) {
            switch (key) {
                case COLUMN_IDS.NAME:
                    url += "&name=iregex:" + value;
                    break;

                case COLUMN_IDS.MATERIAL_ID:
                    url += "&name=iregex:" + value;
                    break;

                default:
                    break;
            }
        }

        return url;
    }

    getListFilterQuery() {
        let query = "";

        for (let [key, value] of this.listFilter) {
            switch (key) {
                case COLUMN_IDS.REGION:
                    query += "&region=" + value;
                    break;

                case COLUMN_IDS.TYPE:
                    query += "&protocol=" + value;
                    break;

                case COLUMN_IDS.STATUS:
                    if (value === EventStatus.PAST) {
                        query += "&end_dt=lt:" + new Date().toISOString();
                    }
                    else if (value === EventStatus.LIVE) {
                        query += "&start_dt=lte:" + new Date().toISOString() + "&end_dt=gte:" + new Date().toISOString();
                    }
                    else if (value === EventStatus.SCHEDULED) {
                        let future = Date.now() + 1000 * 60 * 2;
                        let dt = new Date(future);
                        query += "&start_dt=gt:" + dt.toISOString();
                    }
                    else if (value === EventStatus.UPCOMING) {
                        let future = Date.now() + 1000 * 60 * 2;
                        let dt = new Date(future);
                        query += "&start_dt=gt:" + new Date().toISOString() + "&start_dt=lt:" + dt.toISOString();
                    }
                    break;

                default:
                    break;
            }
        }

        return query;
    }

    doFetch(url, windowDirection, nextPage, replace) {
        // This can be uncommented once changed to security proxy have been confirmed
        const headers = new Headers();
        headers.append("Authorization", `Bearer ${UserService.getToken()}`);

        fetch(url, {
            headers: headers
        }).then(response => {
            response.json().then(data => {
                for (let e of data.events) {
                    e.id = uuid();
                }

                let events = [];

                // Append or prepend latest results if the data is not being replaced
                if (this.state.events.length > 0 && !replace) {
                    if (windowDirection === 1) {
                        events = [...this.state.events, ...data.events];
                    }
                    else if (windowDirection === -1) {
                        events = [...data.events, ...this.state.events];
                    }
                }
                else {
                    // This is a data refresh
                    this.listViewRef.current.setScrollbar(0);
                    events = data.events;
                    this.firstPageRetrieved = nextPage;
                    this.lastPageRetrieved = nextPage;
                }

                // Remove older results from start or end of array depending on window direction
                if (data.events.length > 0) {
                    if (windowDirection === 1) {
                        if (nextPage - this.firstPageRetrieved > 3) {
                            events.splice(0, PAGE_SIZE);
                            this.firstPageRetrieved++;
                            this.listViewRef.current.setScrollbar(this.scrollTop - this.scrollHeight * (PAGE_SIZE / this.state.events.length));
                        }
                        this.lastPageRetrieved = nextPage;
                    }
                    else {
                        if (windowDirection === -1) {
                            if (this.lastPageRetrieved - nextPage > 3) {
                                events.splice(events.length - PAGE_SIZE - 1, PAGE_SIZE);
                                this.lastPageRetrieved--;
                                if (this.listViewRef) {
                                    this.listViewRef.current.setScrollbar(this.scrollHeight * (PAGE_SIZE / this.state.events.length));
                                }
                            }
                            this.firstPageRetrieved = nextPage;
                        }
                    }

                    this.setState({ events: events } );
                }
                else if (replace) {
                    this.setState({ events: events } );
                }

                /* This will not work as intended if placed once in a 'finally' block because it can complete before the
                 * chained promise (response.json()...) has a chance to complete and execute up to this point
                 */
                this.requestInProgress = false;
            });
        }).catch(e => {
            this.setState( { error: e, events: [] } );
            this.requestInProgress = false; // See above comment for why this isn't placed once in a 'finally' block
        });
    }

    handleSearchChange(value, columnId) {
        if (this.search.get(columnId) === value) {
            return;
        }

        if (value === "" || value === undefined || value === null) {
            if (this.search.has(columnId)) {
                this.search.delete(columnId);
            }
            else {
                // User has selected search but there isn't a value yet and we don't want to force a refresh
                return;
            }
        }
        else {
            this.search.set(columnId, value);
        }

        this.handleFetch(0, true);
    }

    handleSortChange(sortOrder, columnId) {
        if (this.sort.columnId === columnId && this.sort.sortOrder === sortOrder) {
            return;
        }

        this.sort = { columnId: columnId, sortOrder: sortOrder };
        this.handleFetch(0, true);
    }

    render() {
        return (
            <div>
                <ListView
                    columns = { LISTVIEW_COLUMNS }
                    contentTableHeight = { window.innerHeight - 124 }
                    data = { this.state.events }
                    extraComponent = { React.createElement(EventData) }
                    noContextMenu = { true }
                    noSelect = { true }
                    handleScroll = { this.handleScroll }
                    handleListFilterChange = { this.handleListFilterChange }
                    handleSearchChange = { this.handleSearchChange }
                    handleSortChange = { this.handleSortChange }
                    ref = { this.listViewRef }
                />
            </div>
        )
    }
}

LivePage.propTypes = {
    // None
}

export default LivePage;
